window.abstractEventBehavior = (function () {
   "use strict";

   var self = {},
      _aTimeoutHandle = [],
      _aIntervalHandle = [],
      _setTimeout = window.setTimeout,
      _setInterval = window.setInterval;

   window.setTimeout = function (fn, time) {
      var handle = _setTimeout(fn, time);
      _aTimeoutHandle.push(handle);
      return handle;
   };

   window.setInterval = function (fn, time) {
      var handle = _setInterval(fn, time);
      _aIntervalHandle.push(handle);
      return handle;
   };

   self.safeSetTimeout = _setTimeout;
   self.safeSetInterval = _setInterval;

   self.reset = function () {
      var i, handler;

      for (i = 0; i < _aTimeoutHandle.length; i++) {
         handler = _aTimeoutHandle[i];
         clearTimeout(handler);
      }

      for (i = 0; i < _aIntervalHandle.length; i++) {
         handler = _aIntervalHandle[i];
         clearInterval(handler);
      }

      _aTimeoutHandle = [];
      _aIntervalHandle = [];
   };

   return self;
}());
